/* re:tones, scroll-triggered reveals. The only motion on the page.
   No parallax, no bounce, no slide-ins.

   The previous version blanket-revealed every element after 3s as a safety
   net. On a 12,000px page that meant everything below the fold was already
   revealed before the reader ever reached it, so the stagger never played.

   Now: IntersectionObserver is primary, with a viewport check bound to
   scroll, resize and visibilitychange as the backstop. Off-screen elements
   keep their animation; nothing on screen can stay hidden. visibilitychange
   matters because a page loaded in a background tab gets no rAF and no
   observer callbacks at all, so the reveal has to be re-run on return. */
(function () {
  var REVEALED = 'rt-in';
  function inView(el, pad) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight + (pad || 0) && r.bottom > -(pad || 0);
  }
  function init() {
    var els = [].slice.call(document.querySelectorAll('.rt-reveal:not(.' + REVEALED + ')'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add(REVEALED); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add(REVEALED); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });

    var ticking = false;
    function sweep() {
      ticking = false;
      var left = 0;
      els.forEach(function (el) {
        if (el.classList.contains(REVEALED)) return;
        if (inView(el, 80)) { el.classList.add(REVEALED); try { io.unobserve(el); } catch (e) {} }
        else left++;
      });
      if (!left) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        document.removeEventListener('visibilitychange', onVis);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }
    function onVis() { if (document.visibilityState === 'visible') sweep(); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('visibilitychange', onVis);
    requestAnimationFrame(sweep);
    setTimeout(sweep, 1200);   // covers a first paint that rAF missed
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* ---- count-up numerals: big figures tick to value when they enter view ---- */
(function(){
  function run(){
    var els=document.querySelectorAll('[data-count]:not([data-counted])');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      els.forEach(function(el){el.setAttribute('data-counted','1')});return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target; io.unobserve(el); el.setAttribute('data-counted','1');
        var raw=el.dataset.count, target=parseFloat(raw);
        if(!isFinite(target)) return;                       // non-numeric: leave as authored
        var dec=(raw.split('.')[1]||'').length, t0=null, dur=1100;
        function settle(){ el.textContent=raw; }            // always end on the authored value
        function frame(t){
          if(!t0) t0=t;
          var k=Math.min(1,(t-t0)/dur), eased=1-Math.pow(1-k,3);
          if(k>=1){ settle(); return; }
          el.textContent=(target*eased).toFixed(dec);
          requestAnimationFrame(frame);
        }
        // Never zero the figure unless the animation can actually run. In a
        // hidden or backgrounded tab rAF does not fire and timers are throttled,
        // so writing '0' first left the hero reading "0 µm" and "2 mL" instead
        // of 8 µm and 50 mL. A wrong spec on screen is worse than no animation.
        if(document.hidden){ settle(); return; }
        var guard=setTimeout(settle, dur+900);
        document.addEventListener('visibilitychange', function(){ if(document.hidden) settle(); });
        el.textContent='0';
        requestAnimationFrame(frame);
        setTimeout(function(){ clearTimeout(guard); settle(); }, dur+1000);
      });
    },{threshold:.5});
    els.forEach(function(el){io.observe(el)});
  }
  document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  run();
})();

/* ---- bar growth ----------------------------------------------------------
   CSS custom properties do not interpolate inside @keyframes without
   @property, and a transition from a base value only runs once the browser
   has painted that base. Both fail for sections that start off-screen.
   So: observe each chart, and when it enters view read the authored --h/--w
   and write the transform. The element is painted by then, so it animates. */
(function(){
  function grow(el, axis){
    var v = getComputedStyle(el).getPropertyValue(axis === 'Y' ? '--h' : '--w').trim();
    if (!v) return;
    requestAnimationFrame(function(){ el.style.transform = 'scale' + axis + '(' + v + ')'; });
  }
  function run(){
    var groups = [
      { sel: '.rt-crows', bar: '.rt-crow__f', axis: 'X' },
      { sel: '.rt-track', bar: '.rt-fill',    axis: 'X' }
    ];
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    groups.forEach(function(g){
      document.querySelectorAll(g.sel + ':not([data-grown])').forEach(function(box){
        var bars = box.querySelectorAll(g.bar);
        if (!bars.length) return;
        box.setAttribute('data-grown','1');
        if (reduce || !('IntersectionObserver' in window)){
          bars.forEach(function(b){ grow(b, g.axis); });
          return;
        }
        new IntersectionObserver(function(entries, io){
          entries.forEach(function(e){
            if (!e.isIntersecting) return;
            io.disconnect();
            bars.forEach(function(b, i){ setTimeout(function(){ grow(b, g.axis); }, i * 130); });
          });
        }, { threshold: 0.25 }).observe(box);
        // a bar left at scaleX(0) reads as "zero", which is wrong data
        setTimeout(function(){ bars.forEach(function(b){ grow(b, g.axis); }); }, 3500);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  run();
})();

/* ---- primary nav dropdown ----
   Lives here rather than in the section file because the nav is rendered by the
   header block, which has no script of its own. Handles click, touch, Escape
   and outside-click; CSS already covers pointer hover. */
(function(){
  function init(){
    document.querySelectorAll('.rt-nav__has:not([data-nav])').forEach(function(li){
      var btn = li.querySelector('.rt-nav__btn');
      if (!btn) return;
      li.setAttribute('data-nav','1');

      var drop = li.querySelector('.rt-nav__drop');
      /* The panel is parked on <body> while open rather than left in the <li>.
         Measured, not assumed: the header is position:sticky inside
         .page-wrapper, which is the scroll container on desktop, so once it is
         stuck it becomes a composited layer and backdrop-filter inside that
         layer cannot sample the scroller's contents. The glass read as a flat
         tint with no blur at every scroll position except the very top, where
         the header is not stuck yet. An identical panel parented to <body>
         blurs correctly at the same position. Do not move it back into the
         <li>. See .rt-nav__drop--portal in retones-a.css. */
      var anchor = null, timer = null,
          desktop = matchMedia('(min-width:900px)'),
          hoverable = matchMedia('(hover:hover)');
      if(drop){ anchor = document.createComment('rt-nav drop'); drop.parentNode.insertBefore(anchor, drop); }

      function place(){
        if(!drop || drop.parentNode !== document.body) return;
        var r = btn.getBoundingClientRect();
        drop.style.left = Math.max(12, Math.round(r.left - 18)) + 'px';
        drop.style.top  = Math.round(r.bottom + 14) + 'px';
      }
      // Write the visual state inline. A class alone was losing to something in
      // the header's own cascade, and a nav that silently will not open is worse
      // than a couple of inline properties.
      function close(){
        clearTimeout(timer);
        li.classList.remove('rt-nav--open');
        btn.setAttribute('aria-expanded','false');
        if(!drop) return;
        drop.classList.remove('rt-nav__drop--on');
        drop.style.display='';
        if(drop.parentNode === document.body){
          timer = setTimeout(function(){           // put it back once it has faded
            if(drop.classList.contains('rt-nav__drop--on')) return;
            drop.classList.remove('rt-nav__drop--portal');
            drop.style.left=''; drop.style.top='';
            anchor.parentNode.insertBefore(drop, anchor);
          }, 320);
        }
      }
      function open(){
        clearTimeout(timer);
        li.classList.add('rt-nav--open');
        btn.setAttribute('aria-expanded','true');
        if(!drop) return;
        drop.style.display='block';
        if(desktop.matches && drop.parentNode !== document.body){
          document.body.appendChild(drop);
          drop.classList.add('rt-nav__drop--portal');
          place();
          drop.getBoundingClientRect();            // settle the closed state first
        }
        drop.classList.add('rt-nav__drop--on');
      }
      function inside(t){ return !!t && (li.contains(t) || (drop && drop.contains(t))); }

      /* CLOSING ON A TIMER WAS A RACE, AND THE POINTER IS THE FACT.

         The pointer crosses a 14px gap and the panel is no longer inside the
         <li>, so mouseleave fires on the way in. That armed a 140ms close which
         the panel's own mouseenter was supposed to cancel, and anything that
         delayed the second event past the deadline shut the menu under the
         hand: a slow diagonal, a paused cursor, a frame lost to the video.

         So the timer no longer decides. It asks where the pointer actually is
         and only closes when the answer is "not here", which cannot race with
         anything. While it is still inside, it simply asks again. */
      var px = -1, py = -1;
      document.addEventListener('pointermove', function(e){
        px = e.clientX; py = e.clientY;
      }, { passive: true });

      function pointerStillInside(){
        if(px < 0) return false;            // no pointer seen yet, e.g. keyboard
        return inside(document.elementFromPoint(px, py));
      }
      function arm(){
        clearTimeout(timer);
        timer = setTimeout(function(){
          if(pointerStillInside()){ arm(); return; }
          close();
        }, 260);
      }

      // pointer hover, same inline path
      li.addEventListener('mouseenter', function(){ if(hoverable.matches) open(); });
      li.addEventListener('mouseleave', function(){ if(hoverable.matches) arm(); });
      if(drop){
        drop.addEventListener('mouseenter', function(){ if(hoverable.matches) clearTimeout(timer); });
        drop.addEventListener('mouseleave', function(){ if(hoverable.matches) arm(); });
      }

      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        li.classList.contains('rt-nav--open') ? close() : open();
      });
      document.addEventListener('click', function(e){ if(!inside(e.target)) close(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
      li.addEventListener('focusout', function(e){
        if(!inside(e.relatedTarget)) close();
      });
      addEventListener('resize', place);
      addEventListener('scroll', place, true);
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* product film: play only while visible, sound stays off until asked for.
   Walks every film on the page. It used to reach for getElementById('rtFilm'),
   which returns the first match only, so the moment a second film section was
   added to a page its sound button did nothing and the ids collided. */
(function(){
  function initFilm(){
    document.querySelectorAll('.rt-film__stage').forEach(function(stage){
      var v = stage.querySelector('.rt-film__v');
      if(!v || v.dataset.rtFilm) return;
      v.dataset.rtFilm = '1';
      var btn = stage.querySelector('.rt-film__sound'),
          txt = btn && btn.querySelector('.rt-film__soundtxt');

      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(e.isIntersecting){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
            else v.pause();
          });
        },{threshold:.35}).observe(v);
      } else if(v.play){ v.play(); }

      if(btn) btn.addEventListener('click', function(){
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        if(txt) txt.textContent = v.muted ? 'Sound off' : 'Sound on';
        /* every other film goes quiet, so two cannot talk over each other */
        if(!v.muted){
          document.querySelectorAll('.rt-film__v').forEach(function(o){
            if(o===v) return;
            o.muted = true;
            var ob = o.closest('.rt-film__stage');
            var obt = ob && ob.querySelector('.rt-film__sound');
            if(obt){ obt.setAttribute('aria-pressed','false');
              var ot = obt.querySelector('.rt-film__soundtxt');
              if(ot) ot.textContent = 'Sound off'; }
          });
          var p=v.play(); if(p&&p.catch) p.catch(function(){});
        }
      });
    });
  }
  if(document.readyState!=='loading') initFilm();
  else document.addEventListener('DOMContentLoaded',initFilm);
  document.addEventListener('shopify:section:load',initFilm);
})();

/* ---- clips that play only while on screen ----
   The product gallery plates and the control clips carry data-rt-play rather
   than the autoplay attribute. Autoplay makes the browser fetch a file as soon
   as the tag is parsed, whatever preload says, so the device page used to pull
   all eight clips (5.7 MB, measured 2026-09-25) before anyone scrolled. Here a
   clip starts when a quarter of it is visible and pauses when it leaves, so a
   clip nobody reaches is never downloaded. Reduced motion and save-data keep
   the poster, the same rule the hero follows. One observer for all of them. */
(function(){
  var io = null, near = null;
  function start(v){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
  function init(){
    var vids = document.querySelectorAll('video[data-rt-play]:not([data-rt-play-on])');
    if(!vids.length) return;
    var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
             || document.documentElement.classList.contains('rt-save');
    if(!still && !io && 'IntersectionObserver' in window){
      io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if(e.isIntersecting) start(v);
          else if(!v.paused) v.pause();
        });
      }, { threshold: .25 });
      /* Warm-up, one screen ahead of the reader. A clip that waits for the
         play observer only starts its download once it is already on screen,
         so the poster held for a beat before motion. Raising preload when the
         clip is a viewport away buffers it in time, and a clip nobody scrolls
         toward is still never fetched. */
      near = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          near.unobserve(e.target);
          if(e.target.preload === 'none') e.target.preload = 'auto';
        });
      }, { rootMargin: '0px 0px 100% 0px' });
    }
    for(var i = 0; i < vids.length; i++){
      var v = vids[i];
      v.setAttribute('data-rt-play-on', '1');
      v.muted = true;            /* a script may only start a muted clip */
      v.playsInline = true;
      if(still) continue;
      if(near) pending.push(v);
      if(io) io.observe(v); else start(v);
    }
    /* armed by the reader's first scroll, never during the load itself, so
       warming a clip can not compete with what the first screen is fetching */
    if(near && pending.length){
      if(scrolled) arm();
      else window.addEventListener('scroll', function(){ scrolled = true; arm(); }, { passive: true, once: true });
    }
  }
  var pending = [], scrolled = false;
  function arm(){ while(pending.length) near.observe(pending.shift()); }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* video row: same sound-off default as the main film */
(function(){
  function init(){
    document.querySelectorAll('.rt-ugc__item:not([data-rt])').forEach(function(item){
      item.setAttribute('data-rt','1');
      var v=item.querySelector('video'), btn=item.querySelector('.rt-ugc__sound'),
          txt=btn&&btn.querySelector('.rt-film__soundtxt');
      if(!v) return;
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(e.isIntersecting){var p=v.play(); if(p&&p.catch) p.catch(function(){});}
            else v.pause();
          });
        },{threshold:.4}).observe(v);
      }
      if(btn) btn.addEventListener('click',function(){
        // only one clip audible at a time
        document.querySelectorAll('.rt-ugc__item video').forEach(function(o){
          if(o!==v){ o.muted=true;
            var ob=o.closest('.rt-ugc__item').querySelector('.rt-ugc__sound');
            if(ob){ ob.setAttribute('aria-pressed','false');
              var ot=ob.querySelector('.rt-film__soundtxt'); if(ot) ot.textContent='Sound off'; }
          }
        });
        v.muted=!v.muted;
        btn.setAttribute('aria-pressed', v.muted?'false':'true');
        if(txt) txt.textContent=v.muted?'Sound off':'Sound on';
        if(!v.muted){var p=v.play(); if(p&&p.catch) p.catch(function(){});}
      });
    });
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

/* ---- heading reveal ----
   Splits headings into one span per word and staggers them in.

   The version before this nested two inline-blocks, clipped with
   overflow:hidden and overrode vertical-align. That combination inflates the
   line box and put multi-line headings one word per line on the live store.
   Here each word stays display:inline and only opacity and blur animate, so
   no box is generated and text-wrap:balance distributes lines exactly as it
   does on an unsplit heading.

   Guards, in order of how badly they are needed:
   - measure the heading before and after the split; if the height changed at
     all, undo it and leave the heading alone
   - reveal anything already on screen on the next frame
   - reveal EVERYTHING after 3s regardless, because a stuck heading is
     invisible text and that is far worse than an unanimated one */
(function(){
  if(!document.documentElement.classList.contains('rt-js')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Emphasis, not decoration. This used to include .rt-h--lg, which is every
     section heading on the site, so roughly fifteen headings per page each
     animated word by word. Everything moving is the same as nothing moving,
     and it reads cheap. Now only the genuine statements animate: the one
     page-scale headline, the science thesis, and the footer statement. Section
     headings still arrive with their block's quiet fade. */
  var SEL = '.rt-h--xl, .rt-doc__thesis, .rt-foot__statement';

  // Builds the spans for one mode and returns the resulting height, so the
  // caller can compare against the unsplit original.
  function build(h, byChar){
    var words = h.textContent.trim().split(/\s+/);
    var frag = document.createDocumentFragment(), unit = 0;
    words.forEach(function(w, i){
      var span = document.createElement('span');
      span.className = 'rt-word';
      if(byChar){
        for(var c = 0; c < w.length; c++){
          var ch = document.createElement('span');
          ch.className = 'rt-char';
          ch.textContent = w[c];
          ch.style.transitionDelay = Math.min(unit * 16, 900) + 'ms';
          span.appendChild(ch);
          unit++;
        }
        unit += 2;
      } else {
        span.textContent = w;
        span.style.transitionDelay = Math.min(i * 38, 700) + 'ms';
      }
      frag.appendChild(span);
      if(i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });
    h.textContent = '';
    h.appendChild(frag);
  }

  function split(h){
    if(h.dataset.rtSplit) return;
    h.dataset.rtSplit = '1';
    // only plain-text headings: anything with a footnote marker or a link is
    // left alone rather than rebuilt
    if(h.children.length || !h.textContent.trim()) return;
    var words = h.textContent.trim().split(/\s+/);
    if(words.length < 2 || words.length > 40) return;
    if(h.textContent.length > 120) return;   // character split gets silly past this

    var before = h.getBoundingClientRect().height;
    var original = h.textContent;

    // Character-level on the two biggest typographic moments, word-level
    // everywhere else. If the character split shifts layout — many inline spans
    // can make text-wrap:balance redistribute lines — fall back to word-level
    // rather than abandoning the reveal entirely.
    var modes = h.matches('.rt-doc__thesis, .rt-h--xl') ? [true, false] : [false];

    function heightWithSpans(){
      var probe = h.cloneNode(true);
      probe.classList.add('rt-in');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;' +
                            'width:' + h.getBoundingClientRect().width + 'px';
      h.parentNode.appendChild(probe);
      var px = probe.getBoundingClientRect().height;
      probe.remove();
      return px;
    }

    for(var m = 0; m < modes.length; m++){
      build(h, modes[m]);
      if(Math.abs(heightWithSpans() - before) <= 1){
        h.classList.add('rt-wsplit');
        return;
      }
      h.textContent = original;          // this mode moved the layout, try the next
    }
    // neither mode was safe: leave the heading exactly as authored
    return;
  }

  function run(){
    var heads = document.querySelectorAll(SEL);
    if(!heads.length) return;
    heads.forEach(split);

    var targets = document.querySelectorAll('.rt-wsplit:not([data-rt-obs])');
    if(!targets.length) return;

    if(reduce || !('IntersectionObserver' in window)){
      targets.forEach(function(t){ t.classList.add('rt-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('rt-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function(t){ t.setAttribute('data-rt-obs','1'); io.observe(t); });

    // Same rule as the section reveals: sweep what is on screen, never
    // blanket-reveal the page. A blanket timeout here meant every heading
    // below the fold had already animated before the reader arrived.
    var tick=false;
    function sweepHeads(){
      tick=false;
      var left=0;
      targets.forEach(function(t){
        if(t.classList.contains('rt-in')) return;
        var r=t.getBoundingClientRect();
        if(r.top < window.innerHeight + 80 && r.bottom > -80) t.classList.add('rt-in');
        else left++;
      });
      if(!left){
        window.removeEventListener('scroll', onS);
        document.removeEventListener('visibilitychange', onV);
      }
    }
    function onS(){ if(!tick){ tick=true; requestAnimationFrame(sweepHeads); } }
    function onV(){ if(document.visibilityState==='visible') sweepHeads(); }
    window.addEventListener('scroll', onS, {passive:true});
    window.addEventListener('resize', onS, {passive:true});
    document.addEventListener('visibilitychange', onV);
    requestAnimationFrame(sweepHeads);
    setTimeout(sweepHeads, 1200);
  }
  if(document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* email popup */
(function(){
  function init(){
    var el=document.getElementById('rtPop'); if(!el||el.dataset.rt) return;
    el.dataset.rt='1';
    var days=parseInt(el.dataset.days,10)||30,
        delay=(parseInt(el.dataset.delay,10)||8)*1000,
        KEY='rt-pop-seen';

    var posted=!!el.querySelector('.rt-pop__done');
    try{
      var until=parseInt(localStorage.getItem(KEY)||'0',10);
      if(!posted && until && Date.now() < until) return;
    }catch(e){}
    if(/\/(cart|checkout)/.test(location.pathname)) return;

    function remember(){
      try{ localStorage.setItem(KEY, String(Date.now()+days*864e5)); }catch(e){}
    }
    var lastFocus=null;
    function open(){
      lastFocus=document.activeElement;
      el.hidden=false;
      /* The class has to land a frame LATER than hidden=false, or there is no
         starting state for the transition to run from. But a frame that never
         comes leaves the dialog present and invisible, and rAF is throttled
         whenever the document is not being painted, which a background tab is.
         The timeout is the same job with a clock that keeps running: whichever
         arrives first wins, and the other is a no-op. CSS also refuses pointer
         events to a dialog without this class, so the invisible state cannot
         block the page even if both somehow fail. */
      var armed=false;
      function arm(){ if(armed) return; armed=true; el.classList.add('rt-pop--in'); }
      requestAnimationFrame(arm);
      setTimeout(arm, 120);
      document.body.style.overflow='hidden';
      var f=el.querySelector('input[type=email]'); if(f) f.focus({preventScroll:true});
    }
    function close(){
      el.classList.remove('rt-pop--in');
      document.body.style.overflow='';
      remember();
      setTimeout(function(){ el.hidden=true; }, 380);
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
    el.querySelectorAll('[data-pop-close]').forEach(function(b){
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape' && !el.hidden) close();
    });
    // trap focus inside the dialog while it is open
    el.addEventListener('keydown', function(e){
      if(e.key!=='Tab' || el.hidden) return;
      var f=el.querySelectorAll('button, input, a[href]');
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });

    if(posted){ open(); remember(); return; }
    setTimeout(open, delay);
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

/* Hero copy synced to the film.
   The tip-array shot lands mid-clip, so the copy swaps to the RPM message
   while it is on screen and swaps back after. Driven by the video's own
   currentTime rather than a wall-clock timer, so it stays in step if the file
   is slow to start or the tab was backgrounded. */
(function(){
  function init(){
    var copy=document.querySelector('.rt-hero__copy[data-sync-in]');
    if(!copy || copy.dataset.rtSync) return;
    var alt=copy.querySelector('.rt-hero__layer--b');
    if(!alt) return;                       // no timed message configured
    var hero=document.querySelector('.rt-hero video, .rt-hero__media video');
    if(!hero) return;
    copy.dataset.rtSync='1';

    // The mobile cut may be a different edit, so it can carry its own swap
    // timings. Falls back to the desktop values when none are set.
    var isPhone = window.matchMedia('(max-width:760px)').matches;
    var inM=parseFloat(copy.dataset.syncInM), outM=parseFloat(copy.dataset.syncOutM);
    var IN  = (isPhone && isFinite(inM))  ? inM  : (parseFloat(copy.dataset.syncIn)||6),
        OUT = (isPhone && isFinite(outM)) ? outM : (parseFloat(copy.dataset.syncOut)||11);

    // Third state, on the closing shot. Optional: with no heading in the
    // markup there is no layer to show, and with no in-point it never fires.
    // Its out-point may legitimately be blank, meaning hold to the end of the
    // clip, so an unset OUT2 reads as Infinity rather than as zero.
    var altC = copy.querySelector('.rt-hero__layer--c');
    var in2M=parseFloat(copy.dataset.sync2InM), out2M=parseFloat(copy.dataset.sync2OutM);
    var IN2  = (isPhone && isFinite(in2M))  ? in2M  : parseFloat(copy.dataset.sync2In),
        OUT2 = (isPhone && isFinite(out2M)) ? out2M : parseFloat(copy.dataset.sync2Out);
    if(!isFinite(OUT2)) OUT2 = Infinity;

    // portrait poster on phones, so the first paint is not a letterboxed still
    var pm=hero.getAttribute('data-poster-mobile');
    if(pm && isPhone && !hero.currentTime){
      hero.setAttribute('poster', pm);
    }

    // reserve the taller of the two so the hero never reflows mid-swap
    function lock(){
      var a=copy.querySelector('.rt-hero__layer--a');
      copy.style.minHeight='';
      // tallest of all three states, or the hero reflows when C swaps in
      var h=Math.max(a.offsetHeight, alt.offsetHeight, altC ? altC.offsetHeight : 0);
      if(h) copy.style.minHeight=h+'px';
    }
    if(document.readyState==='complete') lock();
    else window.addEventListener('load', lock);
    window.addEventListener('resize', lock);
    /* Cormorant is loaded with media="print" and swapped in onload, so at
       window.load the headings are still measuring in the fallback face. The
       display serif is wider, the longest heading gains a line when it swaps,
       and the reserved height was then short by that line. The overflow landed
       on the CTA row underneath, which is the text-through-the-button clipping.
       Re-measure once the real face is in. */
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(lock);

    // Compare against the DOM, not a cached flag. A cached bool desyncs the
    // moment the video is seeked or loops.
    // RPM figure counts up each time the copy swaps in. The real number is in
    // the markup, so a browser that never runs the animation still reads 6,000.
    var rpm=document.getElementById('rtHeroRpm'), rpmRun=null;
    function countRpm(){
      if(!rpm) return;
      var target=parseInt(rpm.dataset.target,10);
      if(!isFinite(target)) return;
      if(document.hidden){ rpm.textContent=target.toLocaleString(); return; }
      if(rpmRun) cancelAnimationFrame(rpmRun);
      /* Hold the figure's finished width while it counts. The digits are
         proportional, so "0" to "6,000" widened the span on every frame and
         pushed the unit beside it along: a run of small layout shifts each
         time the swap came round. Measured once, at the authored value. */
      if(!rpm.dataset.rtW){
        rpm.textContent=target.toLocaleString();
        var w=rpm.getBoundingClientRect().width;
        if(w){ rpm.style.display='inline-block'; rpm.style.minWidth=Math.ceil(w)+'px'; rpm.dataset.rtW='1'; }
      }
      var t0=null, dur=1300;
      function frame(ts){
        if(!t0) t0=ts;
        var k=Math.min(1,(ts-t0)/dur), eased=1-Math.pow(1-k,3);
        rpm.textContent=Math.round(target*eased).toLocaleString();
        if(k<1) rpmRun=requestAnimationFrame(frame); else rpmRun=null;
      }
      rpm.textContent='0';
      rpmRun=requestAnimationFrame(frame);
      // never strand a partial figure if rAF is throttled mid-run
      setTimeout(function(){ if(rpmRun){ cancelAnimationFrame(rpmRun); rpmRun=null; }
                             rpm.textContent=target.toLocaleString(); }, dur+700);
    }

    function sync(){
      var t=hero.currentTime;
      // C wins where the two windows overlap, so a mistyped pair degrades to
      // the later message rather than to both layers fading against each other.
      var wantC = !!altC && isFinite(IN2) && t>=IN2 && t<OUT2,
          wantB = !wantC && t>=IN && t<OUT;
      var isC=copy.classList.contains('is-alt2'), isB=copy.classList.contains('is-alt');
      if(wantC===isC && wantB===isB) return;
      copy.classList.toggle('is-alt', wantB);
      copy.classList.toggle('is-alt2', wantC);
      // the swapped-in headings are not real h1s, so keep the a11y tree honest
      alt.setAttribute('aria-hidden', wantB ? 'false' : 'true');
      if(altC) altC.setAttribute('aria-hidden', wantC ? 'false' : 'true');
      // count only on the entry into B, not on every frame it stays there
      if(wantB && !isB) countRpm();
    }
    /* WHY THE SWAP USED TO DRIFT, since it was never the page load.
       currentTime is exact and the swap has always been keyed to it, so how
       long the file took to start cannot move the cue. The jitter came from
       how OFTEN it was being read: timeupdate fires roughly four times a
       second, so sync() only got to look every ~250 ms and the swap landed
       anywhere inside that window. Different amount every run, which is what
       reads as "sometimes early, sometimes late".

       A rAF loop while the film is playing checks every frame instead, so the
       error drops from ~250 ms to ~16 ms, which is one frame at 60 Hz.

       rAF does not run in a background tab, so timeupdate stays wired as the
       fallback and visibilitychange restarts the loop. Never gate a visible
       state solely on rAF: that is what put the invisible modal over the whole
       site on 2026-08-14. */
    var raf=null;
    function loop(){
      sync();
      raf = (hero.paused || hero.ended) ? null : requestAnimationFrame(loop);
    }
    function startLoop(){ if(!raf) raf=requestAnimationFrame(loop); }
    function stopLoop(){ if(raf){ cancelAnimationFrame(raf); raf=null; } sync(); }

    hero.addEventListener('play', startLoop);
    hero.addEventListener('playing', startLoop);
    hero.addEventListener('pause', stopLoop);
    hero.addEventListener('ended', stopLoop);
    hero.addEventListener('seeked', sync);
    hero.addEventListener('timeupdate', sync);
    document.addEventListener('visibilitychange', function(){
      if(!document.hidden && !hero.paused) startLoop(); else sync();
    });
    if(!hero.paused) startLoop();

    /* ?rtsync — read the cue off the film instead of guessing at it.
       Load the home page with ?rtsync on the end and a readout appears with
       the live currentTime, the two numbers currently configured, and whether
       the swap is showing. Watch for the frame where the tip starts
       vibrating, read the number, type it into the theme editor. No more
       trial and error, and it renders only with the parameter present. */
    if(location.search.indexOf('rtsync')>=0){
      var hud=document.createElement('div');
      hud.style.cssText='position:fixed;left:12px;bottom:12px;z-index:99999;'+
        'font:600 12px/1.6 ui-monospace,SFMono-Regular,Menlo,monospace;white-space:pre;'+
        'background:#17181B;color:#fff;padding:9px 13px;border-radius:8px;pointer-events:none';
      document.body.appendChild(hud);
      setInterval(function(){
        hud.textContent =
          't  '+hero.currentTime.toFixed(2)+' s   of '+(hero.duration||0).toFixed(2)+'\n'+
          'in '+IN+'   out '+OUT+'   '+(copy.classList.contains('is-alt')?'● SHOWING':'○ hidden');
      },50);
    }
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

/* Mobile drawer dressing.
   Horizon renders the drawer as a plain list with a large empty area under it.
   We cannot template that markup from a block, so the brand furniture is
   injected once the drawer exists: a wordmark above the links, and the primary
   action plus support links parked at the bottom. */
(function(){
  function dress(){
    // Horizon renders this as details.menu-drawer-container > div > nav
    var lists=document.querySelectorAll('.menu-drawer__navigation');
    lists.forEach(function(box){
      if(box.dataset.rtDressed) return;
      box.dataset.rtDressed='1';

      var brand=document.createElement('div');
      brand.className='rt rt-drawer__brand';
      brand.innerHTML='<span>re:tones · derma cosmetics</span>';
      box.insertBefore(brand, box.firstChild);

      var foot=document.createElement('div');
      foot.className='rt rt-drawer__foot';
      foot.innerHTML =
        '<a class="rt-pill" href="/products/retones-mts">Shop the device</a>' +
        '<div class="rt-drawer__meta">' +
          '<a href="/account">Account</a>' +
          '<a href="/search">Search</a>' +
          '<a href="/policies/privacy-policy">Privacy</a>' +
        '</div>' +
        '<p class="rt-drawer__note">8 µm nano-tip · Made in Korea · Ships from the US</p>';
      box.appendChild(foot);

      // let the footer sit at the bottom of the available height
      box.style.display='flex';
      box.style.flexDirection='column';
      box.style.minHeight='100%';
    });
  }
  if(document.readyState!=='loading') dress();
  else document.addEventListener('DOMContentLoaded',dress);
  document.addEventListener('shopify:section:load',dress);
  // the drawer is hydrated lazily, so re-run when it appears
  new MutationObserver(dress).observe(document.documentElement,{childList:true,subtree:true});
})();

/* ---- cart: dispatch countdown + recommendations ---- */
(function(){
  function initCutoff(){
    var el=document.getElementById('rtCutoff'); if(!el||el.dataset.rtOn) return;
    el.dataset.rtOn='1';
    var hour=parseInt(el.dataset.hour,10);
    if(!isFinite(hour)) return;
    var days=(el.dataset.days||'1,2,3,4,5').split(',').map(function(d){return parseInt(d,10)});
    var tz=el.dataset.tz||'America/New_York';
    var timeEl=document.getElementById('rtCutoffTime'), msgEl=document.getElementById('rtCutoffMsg');
    var baseMsg=msgEl?msgEl.textContent:'';

    function storeNow(){
      // read the wall clock in the store's timezone, not the visitor's
      try{
        var p=new Intl.DateTimeFormat('en-US',{timeZone:tz,hour12:false,
          weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit'}).formatToParts(new Date());
        var g=function(t){return (p.find(function(x){return x.type===t})||{}).value};
        var wd={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[g('weekday')];
        return {d:wd, h:parseInt(g('hour'),10)%24, m:parseInt(g('minute'),10), s:parseInt(g('second'),10)};
      }catch(e){ return null; }
    }
    function tick(){
      var n=storeNow(); if(!n){ el.hidden=true; return; }
      var secsLeft=((hour - n.h)*3600) - (n.m*60) - n.s;
      var dispatchToday = days.indexOf(n.d)>-1 && secsLeft>0;
      if(dispatchToday){
        var h=Math.floor(secsLeft/3600), m=Math.floor((secsLeft%3600)/60), s=secsLeft%60;
        timeEl.textContent = (h?h+'h ':'') + m + 'm ' + (h?'':s+'s');
        msgEl.textContent = baseMsg;
        el.classList.add('rt-cb__cut--live');
      } else {
        // past cutoff or a non-dispatch day: name the next dispatch day instead
        var names=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        var d=n.d, i=0;
        do { d=(d+1)%7; i++; } while(days.indexOf(d)===-1 && i<8);
        timeEl.textContent='';
        msgEl.textContent='Ships '+names[d];
        el.classList.remove('rt-cb__cut--live');
      }
    }
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function(){ if(!document.hidden) tick(); });
  }

  function initRecs(){
    var box=document.getElementById('rtCartRecs'); if(!box||box.dataset.rtOn) return;
    box.dataset.rtOn='1';
    fetch(box.dataset.url).then(function(r){return r.json()}).then(function(d){
      var items=(d&&d.products)||[];
      if(!items.length){ box.remove(); return; }   // never show an empty module
      var grid=document.getElementById('rtCartRecGrid');
      grid.innerHTML=items.slice(0,4).map(function(p){
        var img=p.featured_image||(p.images&&p.images[0])||'';
        var price=(p.price/100).toFixed(2).replace(/\.00$/,'');
        return '<a class="rt-cb__rec" href="'+p.url+'">'+
               (img?'<img src="'+img+'&width=200" alt="" loading="lazy">':'<span class="rt-cb__recph"></span>')+
               '<b>'+p.title.replace('re:tones ','')+'</b><span>$'+price+'</span></a>';
      }).join('');
      box.hidden=false;
    }).catch(function(){ box.remove(); });
  }

  function boot(){ initCutoff(); initRecs(); }
  if(document.readyState!=='loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ---- header: condenses on scroll ----
   Native scroll only. No scroll hijacking: Lenis-style inertial scrolling
   fights assistive tech and janks on low-end phones, and this brand's own
   motion rule already rules out drift and bounce. */
(function(){
  var header = document.querySelector('.header-section, #shopify-section-sections--27716222222370__header_section, header');
  if(!header) return;
  var ticking = false, on = false;
  function apply(){
    ticking = false;
    var want = window.scrollY > 90;
    if(want === on) return;
    on = want;
    document.documentElement.classList.toggle('rt-scrolled', want);
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(apply); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) apply(); });
  apply();

  /* Publish the height of everything sticky above the fold so the hero can size
     itself to the screen that is actually left. Sized off 84vh, the banner knew
     nothing about the header and ran past the fold on a laptop. */
  function chrome(){
    var group = document.querySelector('.shopify-section-group-header-group');
    var h = header.getBoundingClientRect().height;
    if(group){
      var top = 0;
      Array.prototype.forEach.call(group.children, function(el){
        var r = el.getBoundingClientRect();
        // the announcement bar scrolls away, but it holds the hero down at rest
        if(r.height > 8 && el !== header) top = Math.max(top, r.height);
      });
      h += top;
    }
    if(h > 0) document.documentElement.style.setProperty('--rt-chrome', Math.round(h) + 'px');
  }
  chrome();
  window.addEventListener('resize', chrome, { passive: true });
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(chrome);
})();

/* ---- depth dial ----
   Position AND readout are driven by one rAF loop, so they cannot disagree.
   A CSS travel animation plus a JS reader meant two clocks: if the reader
   stalled, the number said 0.5 while the indicator sat at 1.5. One source. */
(function(){
  function init(){
    var knob=document.querySelector('.rt-dl .dl-knob'),
        val=document.getElementById('rtDialVal'),
        zone=document.getElementById('rtDialZone');
    if(!knob||!val||knob.dataset.rtOn) return;
    knob.dataset.rtOn='1';
    // The band edges are the real quarters of 0.5–1.5 mm. They used to be
    // .28/.55/.8, which put the readout in one band while the value was already
    // in the next; now that the same index also lights a region on the face,
    // being a hundredth of a millimetre out is visible.
    var ZONES=[[0,'SHALLOWEST'],[.25,'UPPER FACE'],[.5,'GENERAL USE'],[.75,'RESILIENT AREAS']];
    var raf=null, t0=null, DUR=6000;

    // The track's geometry lives in the markup, not here, so the indicator can
    // never end up travelling a line the drawing does not have. Solved as a
    // straight interpolation and written as a transform: offset-path:path() is
    // Safari 16+, and without it the indicator parks at the SVG origin.
    var svg=knob.ownerSVGElement,
        A=(svg.getAttribute('data-dl-from')||'40,446').split(',').map(Number),
        B=(svg.getAttribute('data-dl-to')||'520,446').split(',').map(Number),
        host=knob.closest ? knob.closest('.rt-dl') : null;
    function onTrack(f){ return [A[0]+(B[0]-A[0])*f, A[1]+(B[1]-A[1])*f]; }
    function paint(f){
      var p=onTrack(f);
      knob.setAttribute('transform','translate('+p[0].toFixed(2)+','+p[1].toFixed(2)+')');
      val.textContent=(0.5+f).toFixed(2).replace(/0$/,'');
      // One clock for the number, the indicator and the face. The region that
      // lights up is CSS reacting to this attribute, so it cannot disagree with
      // the readout the way a second timer would.
      for(var i=ZONES.length-1;i>=0;i--){
        if(f>=ZONES[i][0]){
          zone.textContent=ZONES[i][1];
          if(host) host.setAttribute('data-dl-zone',String(i+1));
          break;
        }
      }
    }
    var lastPaint=0;
    function frame(ts){
      if(!t0) t0=ts;
      // 30fps is indistinguishable here and halves the work
      if(ts-lastPaint < 32){ raf=requestAnimationFrame(frame); return; }
      lastPaint=ts;
      var el=ts-t0;
      // a lite device gets a finite number of sweeps, then the dial settles at
      // the shallow end rather than holding a rAF open for the rest of the visit
      if(el>=MAX_MS){ raf=null; paint(0); return; }
      spent=el;
      var p=(el%DUR)/DUR;
      // out and back, eased at the turns
      var f = p<.5 ? p*2 : (1-p)*2;
      f = f<0?0:f>1?1:f;
      f = f*f*(3-2*f);
      paint(f);
      raf=requestAnimationFrame(frame);
    }
    /* Hold the readout still until the drawing has finished arriving. Otherwise
       the number is already travelling while the face is still assembling, and
       the two read as unrelated animations. ARC_MS tracks the 1s contour draw
       plus its .05s delay in the stylesheet. */
    // A continuous rAF writing an attribute and a text node is a permanent
    // main-thread cost for a decorative sweep, so a weak device used to get a
    // parked dial instead. Parked meant "broken" to anyone looking at it. It
    // runs everywhere now; on a lite device it runs a bounded number of sweeps
    // and then settles, so the cost is finite rather than the motion absent.
    var LITE=document.documentElement.classList.contains('rt-lite');
    var MAX_MS=LITE?(DUR*2):Infinity, quit=null;
    var ARC_MS=1050, armed=false, hold=null, spent=0;
    function run(){ if(!raf && !document.hidden && spent<MAX_MS) raf=requestAnimationFrame(frame); }
    function start(){
      if(spent>=MAX_MS) return;
      if(armed) return run();
      if(hold) return;
      hold=setTimeout(function(){ hold=null; armed=true; run(); }, ARC_MS);
    }
    function stop(){
      if(hold){ clearTimeout(hold); hold=null; }
      if(raf){ cancelAnimationFrame(raf); raf=null; t0=null; }
    }

    paint(0);   // static state is coherent before anything animates
    // Reduced motion resolves to the shallow end and stays there: the number,
    // the indicator and the lit region all agree, and nothing moves.
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('visibilitychange', function(){ document.hidden?stop():start(); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es[0].isIntersecting?start():stop(); },{threshold:.2})
        .observe(knob.ownerSVGElement);
    } else start();
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

/* ---- scroll progress ----
   A 3px reading indicator in the device gradient. Driven by a rAF-throttled
   scroll listener writing one transform, so it never touches layout. Skipped
   entirely when the document is not tall enough to be worth one. */
(function(){
  function init(){
    if(document.querySelector('.rt-prog')) return;
    if(document.documentElement.classList.contains('rt-lite')) return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var doc = document.documentElement;
    if(doc.scrollHeight - window.innerHeight < 600) return;
    var bar = document.createElement('div');
    bar.className = 'rt-prog';
    bar.setAttribute('aria-hidden','true');
    document.body.appendChild(bar);
    var ticking = false;
    function paint(){
      ticking = false;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + (p < 0 ? 0 : p > 1 ? 1 : p).toFixed(4) + ')';
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ---- science page contents: mark the section you are in ----
   One observer over every anchored block. Uses the topmost intersecting entry
   rather than the last one to fire, so scrolling up marks the right item. */
(function(){
  function init(){
    var toc = document.querySelector('.rt-doc__toc');
    if(!toc || toc.dataset.rtOn) return;
    var links = [].slice.call(toc.querySelectorAll('a[data-toc]'));
    if(!links.length) return;
    toc.dataset.rtOn = '1';

    var map = {};
    var targets = links.map(function(a){
      var el = document.getElementById(a.dataset.toc);
      if(el) map[a.dataset.toc] = a;
      return el;
    }).filter(Boolean);
    if(!targets.length || !('IntersectionObserver' in window)) return;

    var seen = {};
    function mark(){
      // topmost section currently on screen wins
      var best = null, bestTop = Infinity;
      targets.forEach(function(el){
        if(!seen[el.id]) return;
        var t = el.getBoundingClientRect().top;
        if(t < bestTop){ bestTop = t; best = el.id; }
      });
      links.forEach(function(a){
        a.setAttribute('aria-current', String(a.dataset.toc === best));
      });
      if(best && map[best] && toc.scrollHeight > toc.clientHeight){
        var a = map[best], r = a.getBoundingClientRect(), tr = toc.getBoundingClientRect();
        if(r.top < tr.top + 8 || r.bottom > tr.bottom - 8){
          toc.scrollTop += (r.top - tr.top) - toc.clientHeight / 2;
        }
      }
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ seen[e.target.id] = e.isIntersecting; });
      mark();
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });
    targets.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ---- review bodies: clamp only when there is something to clamp ----
   The control is hidden by default and only revealed for entries whose text
   actually overflows three lines, so a two-line review does not get a Show more
   button that does nothing. */
(function(){
  /* Three passes, not one. Clamping an entry and then reading its height
     inside the same loop forced a full style and layout pass per review:
     measured at about 750ms on a throttled phone on the product pages, the
     largest single task the theme ran during load. Now every entry is clamped
     first, all of them are measured against one layout, then the controls are
     settled. Same result per entry. */
  function init(){
    var rows = [];
    document.querySelectorAll('.rt-rv__item:not([data-rt-clamp])').forEach(function(item){
      var body = item.querySelector('[data-rv-body]');
      var btn  = item.querySelector('.rt-rv__more');
      if(!body || !btn) return;
      item.setAttribute('data-rt-clamp','1');
      body.classList.add('is-clamped');
      rows.push([body, btn]);
    });
    // measure against the clamped height; if nothing is cut, drop the control
    rows.forEach(function(r){ r.push(r[0].scrollHeight - r[0].clientHeight < 4); });
    rows.forEach(function(r){
      var body = r[0], btn = r[1];
      if(r[2]){
        body.classList.remove('is-clamped');
        btn.remove();
        return;
      }
      btn.hidden = false;
      btn.setAttribute('aria-expanded','false');
      btn.addEventListener('click', function(){
        var open = body.classList.toggle('is-clamped') === false;
        btn.textContent = open ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ---- hero film on weak hardware or a metered connection ----
   The desktop cut is ~6 MB and decodes 1920x1080 continuously behind the
   headline. On a low-core machine that decode competes with everything else on
   the page, and on save-data it is 6 MB nobody asked for. Drop the sources
   before they are fetched and leave the poster, which is the same first frame,
   so the hero still looks composed rather than broken. */
(function(){
  function init(){
    /* rt-save, not rt-lite: dropping the film is a data decision, not a
       performance one. A 4GB phone can play video perfectly well. */
    if(!document.documentElement.classList.contains('rt-save')) return;
    var v = document.querySelector('.rt-hero__media video');
    if(!v || v.dataset.rtLite) return;
    v.dataset.rtLite = '1';
    v.removeAttribute('autoplay');
    v.autoplay = false;
    try { v.pause(); } catch(e) {}
    // remove sources first, then load(), so the element settles on the poster
    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) srcs[i].removeAttribute('src');
    v.removeAttribute('src');
    try { v.load(); } catch(e) {}
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ---- heading reveal: rule sweep ----
   Replaces the word-split fade on display headings. The text is wrapped once,
   the wrapper carries the clip, and the pseudo-element rule travels across it.
   Nothing per-word and nothing per-character, so no filtered layers and no
   text-wrap reflow — the two things that made the old reveal both expensive
   and fragile. */
(function(){
  function init(){
    if(document.documentElement.classList.contains('rt-lite')) return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Product titles are excluded on purpose: a buy-box heading that animates
    // delays the one thing the reader came to confirm.
    var sel = '.rt-h--xl:not([data-rt-sweep]), .rt-doc__thesis:not([data-rt-sweep])';
    var heads = [].slice.call(document.querySelectorAll(sel));
    if(!heads.length) return;

    heads.forEach(function(h){
      // skip anything already handled by the word splitter, and anything that
      // holds markup we would flatten by moving children
      if(h.classList.contains('rt-wsplit')) return;
      h.setAttribute('data-rt-sweep','1');
      var inner = document.createElement('span');
      inner.className = 'rt-sweep__t';
      while(h.firstChild) inner.appendChild(h.firstChild);
      h.appendChild(inner);
      h.classList.add('rt-sweep');
    });

    if(!('IntersectionObserver' in window)){
      heads.forEach(function(h){ h.classList.add('rt-in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('rt-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    heads.forEach(function(h){ io.observe(h); });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Lens cursor.

   Over the film the pointer becomes the instrument you would actually hold
   over skin: a dermatoscope. A precision ring, the device's five depth steps
   read as an index collar, a crosshair, a centre dot.

   Deliberately narrow: a custom cursor replaces a system affordance, so it only
   runs for a real mouse on a machine with headroom, and never when the visitor
   has asked for less motion — in every excluded case the native cursor is left
   exactly as it was. Position is written straight to a transform inside one rAF
   loop that starts on enter and stops on leave; nothing here reads layout.

   Mounts on anything matching HOSTS, so pointing it at a second film is one
   attribute rather than a second copy of this.
   ============================================================ */
(function(){
  var HOSTS = '.rt-hero__box, [data-rt-lens]';

  var SVG =
    '<div class="rt-lens__in">' +
      '<svg viewBox="0 0 112 112" focusable="false">' +
        '<circle class="rt-lens__ring" cx="56" cy="56" r="53"/>' +
        '<g class="rt-lens__ticks">' +
          '<line x1="14.86" y1="32.25" x2="10.1" y2="29.5"/>' +
          '<line x1="32.25" y1="14.86" x2="29.5" y2="10.1"/>' +
          '<line x1="56" y1="12.5" x2="56" y2="3"/>' +
          '<line x1="79.75" y1="14.86" x2="82.5" y2="10.1"/>' +
          '<line x1="97.14" y1="32.25" x2="101.9" y2="29.5"/>' +
          '<line class="rt-lens__min" x1="20.29" y1="20.29" x2="18.52" y2="18.52"/>' +
          '<line class="rt-lens__min" x1="42.93" y1="7.22" x2="42.28" y2="4.81"/>' +
          '<line class="rt-lens__min" x1="69.07" y1="7.22" x2="69.72" y2="4.81"/>' +
          '<line class="rt-lens__min" x1="91.71" y1="20.29" x2="93.48" y2="18.52"/>' +
        '</g>' +
        '<g class="rt-lens__cross">' +
          '<line x1="56" y1="33" x2="56" y2="45"/>' +
          '<line x1="56" y1="67" x2="56" y2="79"/>' +
          '<line x1="33" y1="56" x2="45" y2="56"/>' +
          '<line x1="67" y1="56" x2="79" y2="56"/>' +
        '</g>' +
        '<circle class="rt-lens__dot" cx="56" cy="56" r="2"/>' +
      '</svg>' +
    '</div>';

  function mount(box){
    if(box.querySelector('.rt-lens')) return;

    var lens = document.createElement('div');
    lens.className = 'rt-lens';
    lens.setAttribute('aria-hidden', 'true');
    lens.innerHTML = SVG;
    box.appendChild(lens);
    box.classList.add('rt-haslens');

    var tx = 0, ty = 0, x = 0, y = 0, raf = 0, on = false, seeded = false;
    var cx = 0, cy = 0;   // last viewport position, so scroll can re-derive tx/ty
    var last = 0;         // previous frame stamp, for frame-rate independence

    function frame(now){
      /* Exponential smoothing with the frame's own delta, not a fixed step. A
         flat per-frame factor makes the lens chase faster on a 120Hz display
         than on 60Hz — same code, two different feels. Solving for elapsed time
         keeps it identical everywhere and removes the stutter that showed up
         whenever a frame ran long.

         SMOOTH is the fraction of remaining distance closed every 16.7ms. High
         enough that the ring reads as the pointer rather than trailing it. */
      var t = now || 0;
      var dt = last ? Math.min(t - last, 64) : 16.7;
      last = t;
      var k = 1 - Math.pow(1 - 0.55, dt / 16.7);
      x += (tx - x) * k;
      y += (ty - y) * k;
      /* Round to whole pixels: sub-pixel transforms force the compositor to
         resample the SVG every frame, which is what made the strokes shimmer. */
      lens.style.transform = 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)';
      if(Math.abs(tx - x) < 0.25 && Math.abs(ty - y) < 0.25){ raf = 0; last = 0; return; }
      raf = requestAnimationFrame(frame);
    }

    function off(){
      if(!on) return;
      on = false; seeded = false;
      lens.classList.remove('is-on', 'is-hot');
      lens.style.willChange = '';
      if(raf){ cancelAnimationFrame(raf); raf = 0; }
      last = 0;
    }

    box.addEventListener('pointermove', function(e){
      if(e.pointerType !== 'mouse') return;
      cx = e.clientX; cy = e.clientY;
      var r = box.getBoundingClientRect();
      tx = cx - r.left;
      ty = cy - r.top;
      if(!seeded){ x = tx; y = ty; seeded = true; }
      if(!on){
        on = true;
        lens.style.willChange = 'transform';
        lens.classList.add('is-on');
      }
      /* The ring closes over anything clickable, so losing the system cursor
         never costs the visitor the one signal that matters. */
      lens.classList.toggle('is-hot',
        !!(e.target.closest && e.target.closest('a,button,[role="button"],input,select,textarea')));
      if(!raf){ last = 0; raf = requestAnimationFrame(frame); }
    });

    /* PRESS. The lens is an instrument, so a click should read as a reading
       being taken rather than as a button being pushed: the aperture dips for a
       beat, and one hairline ring leaves the point and is gone.

       Deliberately not a ripple. A filled expanding disc is the material
       vocabulary and would sit on this film like a foreign component; a single
       1px ring is the same hairline the rest of the site draws with, so the
       gesture belongs to the brand rather than to a framework.

       One node, transform and opacity only, removed by its own animationend. */
    var pressT = 0;

    box.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      if(!on) return;
      /* Over a link or a button the ring has already closed to an aperture and
         the control answers for itself. A second signal there is just noise. */
      if(lens.classList.contains('is-hot')) return;

      lens.classList.add('is-press');
      clearTimeout(pressT);
      pressT = setTimeout(function(){ lens.classList.remove('is-press'); }, 150);

      var r = box.getBoundingClientRect();
      var ping = document.createElement('span');
      ping.className = 'rt-lens__ping';
      ping.style.left = Math.round(e.clientX - r.left) + 'px';
      ping.style.top = Math.round(e.clientY - r.top) + 'px';
      ping.addEventListener('animationend', function(){
        if(ping.parentNode) ping.parentNode.removeChild(ping);
      });
      box.appendChild(ping);
      /* Animations do not run while the document is not being painted, so a
         click landing as the tab is hidden would leave the node behind for as
         long as the page lives. Clicking is repeatable; a leak is not. */
      setTimeout(function(){
        if(ping.parentNode) ping.parentNode.removeChild(ping);
      }, 1400);
    }, { passive: true });

    box.addEventListener('pointerleave', function(){
      clearTimeout(pressT);
      lens.classList.remove('is-press');
      off();
    });

    /* Scrolling moves the box under a stationary pointer. Hiding the lens here
       would strand the visitor with no cursor at all, because the host still
       carries cursor:none — so re-derive the position from the last viewport
       coords instead, and only stand down once the box has left the pointer. */
    window.addEventListener('scroll', function(){
      if(!on) return;
      var r = box.getBoundingClientRect();
      if(cx < r.left || cx > r.right || cy < r.top || cy > r.bottom){ off(); return; }
      tx = cx - r.left;
      ty = cy - r.top;
      if(!raf) raf = requestAnimationFrame(frame);
    }, { passive: true });
  }

  function init(){
    if(!window.matchMedia) return;
    if(!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if(document.documentElement.classList.contains('rt-lite')) return;
    [].forEach.call(document.querySelectorAll(HOSTS), mount);
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Cart confirmation beat.

   The count in the header is the only acknowledgement a shopper gets when an
   add succeeds, and a digit changing in the corner is easy to miss entirely —
   which reads as "the button did nothing" and produces a second click.

   Watches the cart chrome for a change in its own text rather than hooking any
   particular Horizon event, so it keeps working if the theme's internals move.
   ============================================================ */
(function(){
  function init(){
    var icon = document.querySelector('.header-actions__cart-icon');
    if(!icon || icon.getAttribute('data-rt-beat')) return;
    icon.setAttribute('data-rt-beat','1');
    if(!('MutationObserver' in window)) return;

    function digits(el){ return (el.textContent || '').replace(/\D+/g, ''); }
    var was = digits(icon);

    function play(el, cls, ms){
      el.classList.remove(cls);
      /* reading offsetWidth restarts the animation; without it a second add in
         quick succession would not replay. */
      void el.offsetWidth;
      el.classList.add(cls);
      setTimeout(function(){ el.classList.remove(cls); }, ms);
    }

    var mo = new MutationObserver(function(){
      var now = digits(icon);
      if(now === was) return;
      var grew = (parseInt(now,10) || 0) > (parseInt(was,10) || 0);
      was = now;
      if(!grew) return;              /* removals should not celebrate */
      play(icon, 'rt-cartbeat', 560);
      var bubble = icon.querySelector('[class*="cart-bubble"], [class*="count"]') || icon;
      play(bubble, 'rt-countrise', 360);
    });
    mo.observe(icon, { childList:true, subtree:true, characterData:true });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Hero autoplay recovery.

   Mobile autoplay fails for reasons the markup cannot prevent: iOS Low Power
   Mode refuses it outright, Safari rejects it if the muted PROPERTY is not set
   before play() even when the attribute is present, and a backgrounded tab
   drops the attempt. In every one of those cases the old behaviour was a hero
   frozen on its poster with nothing trying again — which is what "sometimes it
   doesn't play" looks like from the outside.

   So: set muted as a property, attempt play, and if it is refused, wait for the
   first real interaction and try once more. Never on rt-save, where the film is
   removed on purpose.
   ============================================================ */
(function(){
  function init(){
    var d = document.documentElement;
    if(d.classList.contains('rt-save')) return;
    var v = document.querySelector('.rt-hero__media video');
    if(!v || v.dataset.rtAuto) return;
    v.dataset.rtAuto = '1';

    /* Safari checks the property, not the attribute, at the moment play() is
       called. Setting both is what makes muted autoplay reliable there. */
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;

    var armed = false;

    function attempt(){
      if(!v.paused) return;
      var p;
      try { p = v.play(); } catch(e) { arm(); return; }
      if(p && p.then) p.then(disarm, arm);
    }

    function onPoke(){ attempt(); }

    function arm(){
      if(armed) return;
      armed = true;
      /* passive so the listeners never delay a scroll, once so they clean
         themselves up the moment the film is running. */
      document.addEventListener('touchstart', onPoke, { passive:true });
      document.addEventListener('pointerdown', onPoke, { passive:true });
      document.addEventListener('scroll', onPoke, { passive:true });
    }
    function disarm(){
      if(!armed) return;
      armed = false;
      document.removeEventListener('touchstart', onPoke);
      document.removeEventListener('pointerdown', onPoke);
      document.removeEventListener('scroll', onPoke);
    }

    attempt();
    /* a tab restored from the background often needs one more nudge */
    document.addEventListener('visibilitychange', function(){
      if(!document.hidden) attempt();
    });
    v.addEventListener('loadeddata', attempt);
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ---- mobile: clamp long body paragraphs behind a toggle --------------------
   Only on phones, and only for copy that is already visible. Anything inside a
   <details> is skipped: it is collapsed already, and clamping a collapsed
   paragraph just hides it twice. */
(function(){
  var MQ = '(max-width: 760px)';
  var SEL = '.rt-fact, .rt-lede, .rt-fx__note, .rt-dl__note, .rt-s8__note';
  function run(){
    if(!window.matchMedia || !matchMedia(MQ).matches) return;
    var ps = document.querySelectorAll(SEL + ':not([data-rt-clamped])');
    for(var i=0;i<ps.length;i++){
      var p = ps[i];
      if(p.closest('details, .rt-fold, .rt-buy, .rt-foot')) continue;
      var text = p.textContent.replace(/\s+/g,' ').trim();
      if(text.length < 210) continue;
      p.setAttribute('data-rt-clamped','1');
      p.classList.add('rt-clamp');
      // Character count is only a guess at line count: a 210-character
      // paragraph can still fit in four lines. Measure after clamping and back
      // out if nothing is actually hidden, so no reader meets a "Read more"
      // that reveals nothing.
      if(p.scrollHeight <= p.clientHeight + 1){
        p.classList.remove('rt-clamp');
        continue;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rt-clamp__more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded','false');
      p.insertAdjacentElement('afterend', btn);
      (function(par, b){
        b.addEventListener('click', function(){
          var open = par.classList.toggle('rt-clamp--open');
          b.textContent = open ? 'Show less' : 'Read more';
          b.setAttribute('aria-expanded', String(open));
        });
      })(p, btn);
    }
  }
  if(document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* ---- header material, driven by how far the reader has scrolled -----------
   The nav is transparent while the hero owns the top of the page, then the
   material fades in as soon as real content is underneath it. Interpolated
   rather than toggled, so there is no step at the threshold, and read through
   rAF so a scroll never does layout work on the input path. */
(function(){
  var hdr = document.querySelector('header.shopify-section-group-header-group');
  if(!hdr) return;
  var FADE_START = 4, FADE_END = 48, last = -1, ticking = false;

  function paint(){
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var a = (y - FADE_START) / (FADE_END - FADE_START);
    a = a < 0 ? 0 : (a > 1 ? 1 : a);
    a = Math.round(a * 100) / 100;
    if(a === last) return;
    last = a;
    hdr.style.setProperty('--rt-chrome', a);
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(paint); } }

  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  paint();
})();

/* ------------------------------------------------------------------
   Button motion.

   Two jobs the CSS cannot do on its own.

   1. The fill starts where the pointer actually landed. Every filled
      button reads --px/--py, and without these it falls back to the
      centre, which is correct for keyboard and for touch that did not
      report a position. Written on pointerdown rather than on click so
      the shape is already right by the time the press state paints.

   2. Add to cart confirms in place. The theme's own button gives no
      feedback until the drawer opens; on a slow connection that reads
      as a dead control. The label lifts out and a confirmation lifts
      in, then it returns. Nothing here submits or blocks the form, so
      if the request fails the button simply goes back to normal.
   ------------------------------------------------------------------ */
(function(){
  if(document.documentElement.classList.contains('rt-lite')) return;

  var FILLABLE = '.rt-btn,.rt-pill,.rt-qz__opt,.rt-band__cta,.rt-nav__btn';

  /* a pointer can be outside the box by the time this runs, so clamp:
     an origin of -49% would grow the fill from off-screen */
  function clamp(v){ return v < 0 ? 0 : (v > 100 ? 100 : v); }
  function setOrigin(b, e, r){
    b.style.setProperty('--px', Math.round(clamp((e.clientX - r.left) / r.width * 100)) + '%');
    b.style.setProperty('--py', Math.round(clamp((e.clientY - r.top) / r.height * 100)) + '%');
  }

  /* where the press landed, as a percentage of the button's own box */
  document.addEventListener('pointerdown', function(e){
    var b = e.target && e.target.closest && e.target.closest(FILLABLE);
    if(!b) return;
    var r = b.getBoundingClientRect();
    if(!r.width || !r.height) return;
    setOrigin(b, e, r);
    /* press on pointer-down, not on click, so it responds to the finger */
    b.classList.add('is-press');
  }, {passive:true, capture:true});

  ['pointerup','pointercancel','pointerleave'].forEach(function(evt){
    document.addEventListener(evt, function(e){
      var b = e.target && e.target.closest && e.target.closest(FILLABLE);
      if(b) b.classList.remove('is-press');
    }, {passive:true, capture:true});
  });

  /* hover also aims the fill, so a mouse user sees it grow from the
     edge they approached from rather than always from the middle */
  document.addEventListener('pointerover', function(e){
    var b = e.target && e.target.closest && e.target.closest(FILLABLE);
    if(!b || e.pointerType !== 'mouse') return;
    var r = b.getBoundingClientRect();
    if(!r.width || !r.height) return;
    setOrigin(b, e, r);
  }, {passive:true, capture:true});

  /* ---- add to cart confirms in place ----

     The first version keyed off a class the real button does not carry, and
     off a fetch the theme does not necessarily route through. Both are
     guesses about the theme's plumbing. This asks the cart instead: note the
     count before the click, then poll briefly and confirm only once it has
     actually gone up. If the add fails, nothing is claimed. */
  function markAdded(btn){
    if(!btn || btn.classList.contains('is-added')) return;
    /* The theme writes the label as a bare text node, and a text node cannot
       be transformed. Wrap it once so it has something to move, and do it
       here rather than in Liquid so this works on every add control on the
       site including the ones the theme owns. */
    if(!btn.querySelector('.rt-btn__label')){
      var moved = false;
      [].slice.call(btn.childNodes).forEach(function(n){
        if(n.nodeType === 3 && n.textContent.trim()){
          var w = document.createElement('span');
          w.className = 'rt-btn__label';
          w.textContent = n.textContent;
          btn.replaceChild(w, n);
          moved = true;
        }
      });
      if(!moved && btn.firstElementChild &&
         !btn.firstElementChild.classList.contains('rt-btn__done')){
        btn.firstElementChild.classList.add('rt-btn__label');
      }
    }
    if(!btn.querySelector('.rt-btn__done')){
      var d = document.createElement('span');
      d.className = 'rt-btn__done';
      d.setAttribute('aria-hidden','true');
      d.textContent = btn.getAttribute('data-added-label') || 'Added';
      btn.appendChild(d);
    }
    btn.classList.add('is-added');
    setTimeout(function(){ btn.classList.remove('is-added'); }, 1700);
  }

  function isAddControl(el){
    if(!el || !el.closest) return null;
    var b = el.closest('button,[data-qz-add],a.rt-btn');
    if(!b) return null;
    if(b.hasAttribute('data-qz-add')) return b;
    if(b.closest('form[action*="/cart/add"]')) return b;
    if(/add to cart|add to bag|add selected/i.test(b.textContent || '')) return b;
    return null;
  }

  document.addEventListener('click', function(e){
    var b = isAddControl(e.target);
    if(!b) return;
    var before = null, tries = 0;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        before = c.item_count;
        (function poll(){
          if(++tries > 14) return;                 /* about 4 seconds, then give up quietly */
          setTimeout(function(){
            fetch('/cart.js', {headers:{'Accept':'application/json'}})
              .then(function(r){ return r.json(); })
              .then(function(c2){
                if(c2.item_count > before) markAdded(b);
                else poll();
              })
              .catch(function(){});
          }, 280);
        })();
      })
      .catch(function(){});
  }, {capture:true});

})();


/* ---- Mobile drawer watchdog ----
   Horizon opens the panel by adding .menu-open inside a requestAnimationFrame.
   <details> itself opens natively and instantly, so those two can separate: if
   the callback is delayed, dropped, or the component failed to connect, the
   drawer is open, its full-screen backdrop is live, and the panel is still
   parked off-screen. The visitor sees the header vanish behind a sheet they
   cannot see and cannot dismiss.

   This does not replace Horizon's logic, it only refuses to let the two states
   disagree: if the element is open a beat later and the class still is not
   there, put it there. Closing is left entirely to Horizon so its exit
   animation is untouched. */
(function(){
  function watch(det){
    if (det.dataset.rtDrawerWatch) return;
    det.dataset.rtDrawerWatch = '1';
    det.addEventListener('toggle', function(){
      // The header is no longer a containing block, so nothing needs to be
      // switched off at open time. This only marks the document, for anything
      // that wants to know the drawer is up.
      document.documentElement.classList.toggle('rt-drawer-open', det.open);
      if (!det.open) return;
      setTimeout(function(){
        if (det.open && !det.classList.contains('menu-open')) {
          det.classList.add('menu-open');
        }
      }, 160);
    });
  }
  function init(){
    document.querySelectorAll('details.menu-drawer-container, #Details-menu-drawer-container')
      .forEach(watch);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* ---- collection grid: reveal each card as it arrives ----
   The grid is Horizon markup, so it carries none of our rt-reveal hooks. Rather
   than fork the card snippet, the cards are observed here and given the same
   class the rest of the site uses, so one motion system covers both. */
(function(){
  function init(){
    var cards = document.querySelectorAll('.product-grid > *:not([data-rt-seen])');
    if (!cards.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)){
      cards.forEach(function(c){ c.setAttribute('data-rt-seen','1'); c.classList.add('rt-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('rt-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    cards.forEach(function(c){ c.setAttribute('data-rt-seen','1'); io.observe(c); });
    // a card left invisible is worse than one that never animated
    setTimeout(function(){ cards.forEach(function(c){ c.classList.add('rt-in'); }); }, 2500);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* FAQ accordion, animated.
   This has to be scripted. A closed <details> does not render its children, so
   there is no first frame for CSS to transition from, which is why the rows
   were snapping open. We take over the toggle, measure the two heights
   ourselves, and animate the element between them with the Web Animations API.
   ::details-content would do it in CSS but is not in every browser yet, and a
   FAQ that animates for some visitors and jumps for the rest is worse than one
   that behaves the same everywhere.

   The native toggle still happens: we only delay setting open=false until the
   collapse has finished, so keyboard, search-in-page and no-JS all still work. */
(function(){
  var DUR = 360, EASE = 'cubic-bezier(.22,.61,.36,1)';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wire(d){
    if (d.dataset.rtAcc) return;
    d.dataset.rtAcc = '1';
    var sum = d.querySelector('summary');
    if (!sum) return;

    sum.addEventListener('click', function(e){
      if (reduce) return;                        // let the browser open it flat
      if (typeof d.animate !== 'function') return;
      e.preventDefault();
      run(d, sum, !d.open);
    });
  }

  function run(d, sum, toOpen){
    if (d._rtA) { d._rtA.cancel(); d._rtA = null; }

    var startH = d.offsetHeight;
    if (toOpen) d.open = true;                   // content has to exist to be measured

    d.style.height = 'auto';
    var endH = toOpen ? d.offsetHeight : sum.offsetHeight;
    d.style.height = startH + 'px';
    d.style.overflow = 'hidden';

    // nothing to animate between, so do not leave the row mid-collapse
    if (startH === endH){ settle(d, toOpen); return; }

    d.classList.toggle('rt-acc-opening', toOpen);
    d._rtA = d.animate({ height: [startH + 'px', endH + 'px'] },
                       { duration: DUR, easing: EASE });
    d._rtA.onfinish = function(){ d._rtA = null; settle(d, toOpen); };
    d._rtA.oncancel = function(){ d._rtA = null; };
  }

  function settle(d, toOpen){
    d.style.height = '';
    d.style.overflow = '';
    d.classList.remove('rt-acc-opening');
    if (!toOpen) d.open = false;                 // only now, or the content vanishes first
  }

  function init(){
    document.querySelectorAll('.rt-faq details, details.rt-fold').forEach(wire);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* Drawer close, animated.
   Opening was smooth because the panel is already rendered by the time the
   transition starts. Closing was not: Horizon drops the `open` attribute the
   moment you click, the panel and its backdrop stop rendering in that frame,
   and the header snaps back with nothing to transition. Same trap as the FAQ.

   We hold `open` for the length of the close transition, tag the drawer so the
   CSS can run the exit, then let it close. Escape and the backdrop go through
   the same path. If anything throws we fall back to the native behaviour, so
   the menu can never end up stuck open. */
(function(){
  var OUT = 380;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shut(det){
    if (reduce || det.dataset.rtShutting) return false;
    det.dataset.rtShutting = '1';
    det.classList.add('rt-drawer-closing');
    document.documentElement.classList.add('rt-drawer-closing');
    setTimeout(function(){
      det.classList.remove('rt-drawer-closing');
      document.documentElement.classList.remove('rt-drawer-closing');
      det.open = false;                    // this fires toggle, hence the flag
      requestAnimationFrame(function(){ delete det.dataset.rtShutting; });
    }, OUT);
    return true;
  }

  function wire(det){
    if (det.dataset.rtDrawer) return;
    det.dataset.rtDrawer = '1';
    /* preventDefault on the summary is not enough: Horizon closes the drawer
       from its own script, so the attribute is already gone by the time our
       handler runs. We watch the toggle instead, put `open` straight back for
       the length of the exit, and only then let it close for real. The panel
       re-renders in the same frame, so nothing flashes. */
    det.addEventListener('toggle', function(){
      if (det.open) return;                 // opening
      if (det.dataset.rtShutting) return;   // our own final close
      det.open = true;
      /* commit the re-opened layout before the exit starts, or the browser has
         no at-rest frame to move away from and collapses it to a jump. Same
         trap as the FAQ, one level up. */
      /* one painted frame at the open position first. A forced reflow is not
         enough here: the panel was un-rendered the instant Horizon dropped
         `open`, so it needs a real frame on screen before it has anything to
         transition away from. Two rAFs guarantees that. */
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){ shut(det); });
      });
    });
    var close = det.querySelector('.menu-drawer__close-button');
    if (close) close.addEventListener('click', function(e){
      if (det.open && shut(det)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    var scrim = det.querySelector('.menu-drawer__backdrop');
    if (scrim) scrim.addEventListener('click', function(e){
      if (det.open && shut(det)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function init(){
    /* .header__drawer is a DIV; the <details> that actually holds the open
       state is inside it, wrapping .menu-drawer. Wiring the div meant
       det.open was undefined and the whole handler never ran. */
    document.querySelectorAll('.header__drawer details').forEach(wire);
    document.querySelectorAll('.menu-drawer').forEach(function(panel){
      var det = panel.closest('details');
      if (det) wire(det);
    });
  }
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.header__drawer details[open]');
    if (d && shut(d)) e.preventDefault();
  }, true);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* ============================================================
   Collection grid: hover crossfades to the second photograph
   ------------------------------------------------------------
   The homepage row does this in Liquid, because that markup is ours. The
   collection grid is Horizon's card-gallery, and its own hover preview is a
   slideshow that SCROLLS its track to slide two. A scroll cannot be turned
   into a crossfade with CSS, so this lays our own frame over the top instead
   of trying to reshape theirs.

   Nothing is disabled. Horizon still scrolls its track underneath, and it
   still resets on leave, but it does all of that behind an opaque overlay so
   none of it is visible. When the overlay fades out it reveals the base frame,
   which is the frame Horizon has already reset to. The two never disagree.

   The overlay is cloned from the second slide, which is in the DOM already
   whenever the theme's show_second_image_on_hover is on, so this adds no
   network request and there is no blank first hover.

   pointer-events:none is load-bearing: the overlay is appended to the gallery,
   which is OUTSIDE the card's <a>. Without it, a click on the second image
   would land on nothing instead of opening the product.
   ============================================================ */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function build(gallery) {
    if (gallery.dataset.rtSwap) return;
    var frames = gallery.querySelectorAll('.product-media__image');
    /* one image, or a video in slot two: leave the card exactly as it was */
    if (frames.length < 2) { gallery.dataset.rtSwap = 'single'; return; }

    var source = frames[1];
    var overlay = document.createElement('img');
    overlay.className = 'rt-cgswap';
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.loading = 'lazy';
    overlay.decoding = 'async';
    if (source.getAttribute('srcset')) {
      overlay.srcset = source.getAttribute('srcset');
      overlay.sizes = source.getAttribute('sizes') || '';
    }
    overlay.src = source.currentSrc || source.src;
    /* match the base frame rather than assume cover: the grid serves square
       plates and a mismatch here would crop one frame and not the other, so
       the swap would jump instead of dissolve */
    overlay.style.objectFit = getComputedStyle(source).objectFit;
    overlay.style.objectPosition = getComputedStyle(source).objectPosition;

    gallery.appendChild(overlay);
    gallery.dataset.rtSwap = 'on';
  }

  /* The homepage row ships its second frame with no src, so a phone never
     fetches a photograph it has no way to reveal. Give it one here, where we
     already know the device has a real pointer. Done at idle so it queues
     behind everything that paints. */
  function arm(root) {
    (root || document).querySelectorAll('img[data-rt-src]').forEach(function (img) {
      if (img.getAttribute('src')) return;
      img.loading = 'lazy';
      img.src = img.getAttribute('data-rt-src');
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-gallery').forEach(build);
    if ('requestIdleCallback' in window) requestIdleCallback(function () { arm(root); }, { timeout: 2500 });
    else setTimeout(function () { arm(root); }, 600);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  /* the grid paginates and filters in place, so new cards arrive after load */
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('card-gallery')) build(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();


/* Cart deadline pill.

   Counts down to the single merchant-set moment in settings.rt_deadline. The
   rules that keep it honest live here, not in copy: an unparseable or past
   deadline removes the pill outright, and there is no reset, no per-visitor
   clock and no loop. It shows one real deadline or nothing.

   Runs on [data-rt-deadline], which the cart drawer renders hidden; the first
   valid tick reveals it. One interval serves every instance on the page. */
(function(){
  function fmt(ms){
    var s=Math.max(0,Math.floor(ms/1000));
    var h=Math.floor(s/3600), m=Math.floor((s%3600)/60), x=s%60;
    var mm=(m<10?'0':'')+m, xx=(x<10?'0':'')+x;
    return h>0 ? h+':'+mm+':'+xx : mm+':'+xx;
  }
  function boot(){
    var els=[].slice.call(document.querySelectorAll('[data-rt-deadline]:not([data-rt-ddl-live])'));
    if(!els.length) return;
    var live=[];
    els.forEach(function(el){
      el.setAttribute('data-rt-ddl-live','1');
      var t=Date.parse(el.getAttribute('data-rt-deadline'));
      if(!isFinite(t) || t-Date.now()<=0){ el.remove(); return; }
      live.push({el:el, t:t, out:el.querySelector('[data-rt-ddl-out]')});
    });
    if(!live.length) return;
    function tick(){
      var now=Date.now(), any=false;
      live.forEach(function(o){
        if(!o.el.isConnected) return;
        var left=o.t-now;
        if(left<=0){ o.el.remove(); return; }
        any=true;
        o.el.hidden=false;
        if(o.out) o.out.textContent=fmt(left);
        o.el.classList.toggle('rt-ddl--soon', left<600000);
      });
      if(!any) clearInterval(iv);
    }
    var iv=setInterval(tick,1000); tick();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();


/* Same-day dispatch cutoff pill.

   Shows only while "ships today" is true: today is a dispatch day in the
   warehouse timezone AND the cutoff has not passed. Outside that window the
   pill hides itself, and at the next dispatch morning it reappears on its
   own, because the fact it states has come back. Clock math runs in the
   merchant timezone via Intl, so a visitor in Seoul sees the same truth as
   one in Atlanta. */
(function(){
  function tzParts(tz){
    try{
      var f=new Intl.DateTimeFormat('en-GB',{timeZone:tz,hour12:false,
        weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit'});
      var p={}; f.formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
      var dow={Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6,Sun:7}[p.weekday];
      return {dow:dow, sec:(+p.hour)*3600+(+p.minute)*60+(+p.second)};
    }catch(e){ return null; }
  }
  function fmt(s){
    var h=Math.floor(s/3600), m=Math.floor((s%3600)/60), x=s%60;
    var mm=(m<10?'0':'')+m, xx=(x<10?'0':'')+x;
    return h>0 ? h+':'+mm+':'+xx : mm+':'+xx;
  }
  function boot(){
    var els=[].slice.call(document.querySelectorAll('[data-rt-cutoff]:not([data-rt-cut-live])'));
    if(!els.length) return;
    var live=[];
    els.forEach(function(el){
      el.setAttribute('data-rt-cut-live','1');
      var m=/^(\d{1,2}):(\d{2})$/.exec(el.getAttribute('data-rt-cutoff')||'');
      if(!m){ el.remove(); return; }
      var days=(el.getAttribute('data-rt-cutoff-days')||'1,2,3,4,5').split(',').map(Number);
      live.push({el:el, cut:(+m[1])*3600+(+m[2])*60, days:days,
                 tz:el.getAttribute('data-rt-cutoff-tz')||'America/New_York',
                 out:el.querySelector('[data-rt-ddl-out]')});
    });
    if(!live.length) return;
    function tick(){
      /* Stop when nothing this interval owns is still in the document. The cart
         drawer re-renders on every cart mutation, which detaches these pills and
         leaves boot() to create a fresh interval for the new ones; without this
         the old interval would keep ticking over dead nodes for the life of the
         page, once per cart update. The deadline ticker above already does this. */
      var alive=false;
      live.forEach(function(o){
        if(!o.el.isConnected) return;
        alive=true;
        var now=tzParts(o.tz);
        if(!now){ o.el.remove(); return; }
        var inWindow=o.days.indexOf(now.dow)>=0 && now.sec<o.cut;
        o.el.hidden=!inWindow;
        if(inWindow){
          var left=o.cut-now.sec;
          if(o.out) o.out.textContent=fmt(left);
          o.el.classList.toggle('rt-ddl--soon', left<3600);
        }
      });
      if(!alive) clearInterval(iv);
    }
    var iv=setInterval(tick,1000); tick();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* ---- looping CSS motion rests while it is off screen ----
   A handful of decorative loops run forever: the coming-soon teaser's float,
   ring, breath, blink and sheen, the gallery ribbon, the card rim. Several of
   them animate box-shadow or background-position, which the compositor cannot
   take, so every one of them cost a style pass and a repaint on every frame of
   the visit, including the whole time it sat a dozen screens away. Measured on
   a throttled phone that was a steady 40ms of style work per frame on the home
   page long after load.

   Nothing changes on screen. Each section holding an infinite loop is watched,
   and while no part of it is in view its loops are paused in place, then
   resumed from the same point as it comes back, a screen before it is seen.
   Found from the running animations rather than a hand kept list, so a loop
   added later is covered without anyone remembering this. */
(function(){
  if(!('IntersectionObserver' in window) || !document.getAnimations) return;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null, io = null;
  function scan(){
    var list;
    try{ list = document.getAnimations(); }catch(e){ return; }
    for(var i = 0; i < list.length; i++){
      var a = list[i], t, k;
      if(!a.animationName) continue;                       /* CSS animations only, never transitions */
      try{ if(a.effect.getComputedTiming().iterations !== Infinity) continue; }catch(e){ continue; }
      t = a.effect && a.effect.target;
      if(!t || !t.closest) continue;
      k = t.closest('.shopify-section') || t;
      /* the announcement bar sits in the sticky header, which is always on screen */
      if(k.closest('#header-group')) continue;
      if(!seen || seen.has(k)) continue;
      seen.add(k);
      if(!io) io = new IntersectionObserver(function(es){
        es.forEach(function(e){ e.target.classList.toggle('rt-anim-off', !e.isIntersecting); });
      }, { rootMargin: '100% 0px 100% 0px' });
      io.observe(k);
    }
  }
  function later(){
    if(window.requestIdleCallback) requestIdleCallback(scan, { timeout: 3000 });
    else setTimeout(scan, 1200);
  }
  if(document.readyState === 'complete') later();
  else window.addEventListener('load', later);
  document.addEventListener('shopify:section:load', later);
})();
